import { EscalationKey } from "../enums/Escalations";
import { MESSAGES } from "../messages";

export const ESCALATION_LABELS: Record<EscalationKey, string> =
  MESSAGES.STEWARDSHIP.ENGAGEMENT_MODULE.ESCALATION_SHORT;

export const getEscalationLabel = (key: EscalationKey): string =>
  ESCALATION_LABELS[key];